export class WcsAkamaiCookies {
  static ALBANIA = 'AL'
  static ALGERIA = 'DZ'
  static ARGENTINA = 'AR'
  static ARMENIA = 'AM'
  static BAHRAIN = 'BH'
  static BANGLADESH = 'BD'
  static BOSNIA_AND_HERZEGOVINA = 'BA'
  static BULGARIA = 'BG'
  static CHILE = 'CL'
  static COSTA_RICA = 'CR'
  static ESTONIA = 'EE'
  static FINLAND = 'FI'
  static GREECE = 'GR'
  static LATVIA = 'LV'
  static LITHUANIA = 'LT'
  static LUXEMBOURG = 'LU'
  static SLOVAKIA = 'SK'
  static SLOVENIA = 'SI'
  static CYPRUS = 'CY'
  static COLOMBIA = 'CO'
  static CROATIA = 'HR'
  static CZECH_REPUBLIC = 'CZ'
  static ECUADOR = 'EC'
  static EGYPT = 'EG'
  static GEORGIA = 'GE'
  static HUNGARY = 'HU'
  static INDONESIA = 'ID'
  static ISRAEL = 'IL'
  static ISLAND = 'IS'
  static ITALY = 'IT'
  static IVORY_COAST = 'CI'
  static JORDAN = 'JO'
  static KOSOVO = 'XK'
  static KUWAIT = 'KW'
  static LEBANON = 'LB'
  static MALAYSIA = 'MY'
  static MONTENEGRO = 'ME'
  static MOROCCO = 'MA'
  static MYANMAR = 'MM'
  static NORTH_MACEDONIA = 'MK'
  static OMAN = 'OM'
  static PAKISTAN = 'PK'
  static PERU = 'PE'
  static QATAR = 'QA'
  static ROMANIA = 'RO'
  static RUSSIA = 'RU'
  static SAUDI_ARABIA = 'SA'
  static SENEGAL = 'SN'
  static SERBIA = 'RS'
  static SINGAPORE = 'SG'
  static SOUTH_AFRICA = 'ZA'
  static SRI_LANKA = 'LK'
  static TAIWAN = 'TW'
  static THAILAND = 'TH'
  static TUNISIA = 'TN'
  static TURKEY = 'TR'
  static UKRAINE = 'UA'
  static UNITED_ARAB_EMIRATES = 'AE'
  static URUGUAY = 'UY'
  static VIETNAM = 'VN'
  static AZERBAIJAN = 'AZE'
  static WORLD_WIDE = 'WW'

  static LATAM_CC = 'LATAM'
  static ASEAN_CC = 'ASEAN'
  static ROW_CC = 'ROW'
  static SEE_CC = 'SEE'
  static MEA_CC = 'MEA'
  static INT_CC = 'INT'

  static readonly SOUTHEAST_ASIAN_NATIONS = [
    WcsAkamaiCookies.ASEAN_CC,
    WcsAkamaiCookies.THAILAND,
    WcsAkamaiCookies.SINGAPORE,
    WcsAkamaiCookies.MALAYSIA,
    WcsAkamaiCookies.INDONESIA,
    WcsAkamaiCookies.TAIWAN,
  ]
  static readonly SOUTHEAST_EUROPE = [
    WcsAkamaiCookies.SEE_CC,
    WcsAkamaiCookies.SERBIA,
    WcsAkamaiCookies.MONTENEGRO,
    WcsAkamaiCookies.NORTH_MACEDONIA,
    WcsAkamaiCookies.GEORGIA,
    WcsAkamaiCookies.BULGARIA,
    WcsAkamaiCookies.ARMENIA,
    WcsAkamaiCookies.BOSNIA_AND_HERZEGOVINA,
    WcsAkamaiCookies.ALBANIA,
    WcsAkamaiCookies.KOSOVO,
  ]
  static readonly INTERNATIONAL = [
    WcsAkamaiCookies.INT_CC,
    WcsAkamaiCookies.MYANMAR,
    WcsAkamaiCookies.SRI_LANKA,
    WcsAkamaiCookies.BANGLADESH,
  ]

  static readonly REST_OF_WORLD = [
    WcsAkamaiCookies.ROW_CC,
    WcsAkamaiCookies.ISRAEL,
    WcsAkamaiCookies.ISLAND,
    WcsAkamaiCookies.ROMANIA,
    WcsAkamaiCookies.RUSSIA,
    WcsAkamaiCookies.UKRAINE,
    WcsAkamaiCookies.CROATIA,
    WcsAkamaiCookies.HUNGARY,
    WcsAkamaiCookies.CZECH_REPUBLIC,
    WcsAkamaiCookies.SOUTH_AFRICA,
    WcsAkamaiCookies.WORLD_WIDE,
    WcsAkamaiCookies.PAKISTAN,
    WcsAkamaiCookies.VIETNAM,
    WcsAkamaiCookies.AZERBAIJAN,
    ...WcsAkamaiCookies.SOUTHEAST_EUROPE,
    ...WcsAkamaiCookies.INTERNATIONAL,
  ]

  static readonly LATIN_AMERICA = [
    WcsAkamaiCookies.LATAM_CC,
    WcsAkamaiCookies.ARGENTINA,
    WcsAkamaiCookies.CHILE,
    WcsAkamaiCookies.COLOMBIA,
    WcsAkamaiCookies.PERU,
    WcsAkamaiCookies.ECUADOR,
    WcsAkamaiCookies.URUGUAY,
    WcsAkamaiCookies.COSTA_RICA,
  ]

  static readonly MIDDLE_EAST = [
    WcsAkamaiCookies.MEA_CC,
    WcsAkamaiCookies.UNITED_ARAB_EMIRATES,
    WcsAkamaiCookies.BAHRAIN,
    WcsAkamaiCookies.KUWAIT,
    WcsAkamaiCookies.LEBANON,
    WcsAkamaiCookies.QATAR,
    WcsAkamaiCookies.SAUDI_ARABIA,
    WcsAkamaiCookies.ALGERIA,
    WcsAkamaiCookies.EGYPT,
    WcsAkamaiCookies.IVORY_COAST,
    WcsAkamaiCookies.JORDAN,
    WcsAkamaiCookies.OMAN,
    WcsAkamaiCookies.MOROCCO,
    WcsAkamaiCookies.SENEGAL,
    WcsAkamaiCookies.TUNISIA,
  ]

  static readonly NO_ECOMMERCE_COUNTRY_CODES = [
    ...WcsAkamaiCookies.SOUTHEAST_ASIAN_NATIONS,
    ...WcsAkamaiCookies.REST_OF_WORLD,
    ...WcsAkamaiCookies.LATIN_AMERICA,
    ...WcsAkamaiCookies.MIDDLE_EAST,
    WcsAkamaiCookies.TURKEY,
  ]

  static readonly NO_ECOMMERCE_WITH_PRICES_COUNTRY_CODES = [WcsAkamaiCookies.TAIWAN]

  static readonly NO_ECOMMERCE_REGIONS = [
    WcsAkamaiCookies.LATAM_CC,
    WcsAkamaiCookies.ASEAN_CC,
    WcsAkamaiCookies.ROW_CC,
    WcsAkamaiCookies.SEE_CC,
    WcsAkamaiCookies.INT_CC,
    WcsAkamaiCookies.MEA_CC,
  ]

  static readonly EUROPEAN_COUNTRIES = [
    WcsAkamaiCookies.ALBANIA,
    WcsAkamaiCookies.BOSNIA_AND_HERZEGOVINA,
    WcsAkamaiCookies.BULGARIA,
    WcsAkamaiCookies.CROATIA,
    WcsAkamaiCookies.CZECH_REPUBLIC,
    WcsAkamaiCookies.HUNGARY,
    WcsAkamaiCookies.ITALY,
    WcsAkamaiCookies.MONTENEGRO,
    WcsAkamaiCookies.NORTH_MACEDONIA,
    WcsAkamaiCookies.ROMANIA,
    WcsAkamaiCookies.SERBIA,
    WcsAkamaiCookies.UKRAINE,
    WcsAkamaiCookies.SEE_CC,
  ]

  static readonly SOUTH_AMERICA_COUNTRIES = [
    WcsAkamaiCookies.ARGENTINA,
    WcsAkamaiCookies.CHILE,
    WcsAkamaiCookies.COLOMBIA,
    WcsAkamaiCookies.ECUADOR,
    WcsAkamaiCookies.PERU,
    WcsAkamaiCookies.LATAM_CC,
  ]

  static readonly ASIAN_COUNTRIES = [
    WcsAkamaiCookies.ARMENIA,
    WcsAkamaiCookies.BAHRAIN,
    WcsAkamaiCookies.BANGLADESH,
    WcsAkamaiCookies.GEORGIA,
    WcsAkamaiCookies.INDONESIA,
    WcsAkamaiCookies.ISRAEL,
    WcsAkamaiCookies.JORDAN,
    WcsAkamaiCookies.KUWAIT,
    WcsAkamaiCookies.LEBANON,
    WcsAkamaiCookies.MALAYSIA,
    WcsAkamaiCookies.MYANMAR,
    WcsAkamaiCookies.OMAN,
    WcsAkamaiCookies.PAKISTAN,
    WcsAkamaiCookies.QATAR,
    WcsAkamaiCookies.RUSSIA,
    WcsAkamaiCookies.SAUDI_ARABIA,
    WcsAkamaiCookies.SINGAPORE,
    WcsAkamaiCookies.SRI_LANKA,
    WcsAkamaiCookies.TAIWAN,
    WcsAkamaiCookies.THAILAND,
    WcsAkamaiCookies.TURKEY,
    WcsAkamaiCookies.UNITED_ARAB_EMIRATES,
    WcsAkamaiCookies.VIETNAM,
    WcsAkamaiCookies.ASEAN_CC,
    WcsAkamaiCookies.MEA_CC,
  ]

  static readonly AFRICAN_COUNTRIES = [
    WcsAkamaiCookies.ALGERIA,
    WcsAkamaiCookies.EGYPT,
    WcsAkamaiCookies.IVORY_COAST,
    WcsAkamaiCookies.MOROCCO,
    WcsAkamaiCookies.SENEGAL,
    WcsAkamaiCookies.SOUTH_AFRICA,
    WcsAkamaiCookies.TUNISIA,
  ]
}
